import React, {useEffect, useState} from "react";
import {Outlet, useLocation} from "react-router";
import {useDispatch} from "react-redux";
import {LeftBar} from "./leftBar";
import {authActions} from "store";
import {token, userType} from "utils";

export const Layout = () => {
    const [openingMenu, setOpeningMenu] = useState(true);
    const dispatch = useDispatch();
    const {pathname} = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    useEffect(() => {
        if (token) {
            dispatch(authActions.getMyProfile(userType));
        }
    }, [dispatch, userType, token]);

    const toggleMenu = () => {
        setOpeningMenu((prev) => !prev);
    };
    return (
        <div className="layout-wrapper">
            <LeftBar toggleMenu={toggleMenu} openingMenu={openingMenu}/>

            <div
                className="layout-content"
                style={{
                    width: openingMenu ? "calc(100% - 262px)" : "calc(100% - 72px)",
                }}
            >
                <Outlet/>
            </div>
        </div>
    );
};
